define('home/viewmodels/DiscussionCreateViewModel',[
    'underscore',
    'backbone',

    'home/utils/backboneUtils',

    'home/models/Thread',
    'home/models/Topic',
    'core/UniqueModel',
    'home/collections/TopicCollection',
], function (
    _,
    Backbone,

    backboneUtils,

    Thread,
    Topic,
    UniqueModel,
    TopicCollection
) {
    'use strict';

    var DiscussionCreateViewModel = Backbone.Model.extend({
        editableThreadAttrs: [
            'title',
            'message',
        ],

        initialize: function (_attributes, options) {
            this.thread = options.thread || new Thread({
                forum: options.forum,
            });

            // Add forum details so that they are available for rendering on the
            // Discussion page when this form is submitted
            if (this.thread.forum.shouldFetch())
                this.thread.forum.fetch();

            this.topics = new TopicCollection([], { thread: this.thread });

            this.listenTo(this, 'change:category', this.updateTopicCategory);

            backboneUtils.getPromiseFor(this.thread, 'id').then(_.bind(this.onThreadInit, this));
        },

        onThreadInit: function () {
            UniqueModel.set(Thread, this.thread);

            // Copy the attributes needed for the view onto this. This will store
            // the value as shown in the view, that can be edited. The value will
            // not be updated on the thread model until the changes are saved.
            // This way if the edit is cancelled, the thread model is in the
            // correct unchanged state.
            this.set(this.thread.pick(this.editableThreadAttrs));

            this.topics.add(this.thread.topics.models);

            this.initCategory();
        },

        initCategory: function () {
            var channel = this.thread.forum.channel;
            var categories = channel && channel.getCategories();

            if (!categories)
                return;

            // Since categories are chosen by adding the category as a topic, technically
            // a thread could have multiple categories. Topic Collection validation should
            // prevent this, so assume the chosenCategories returned has max length 1.
            var chosenCategories = this.topics.getCategoryTopics();

            // TODO remove
            // Temporary backwards compatibility, parses the category from the title prefix
            // where it used to be stored before it used topics
            if (!chosenCategories.length) {
                var titlePrefix = this.get('title').split(Thread.CATEGORY_TITLE_SEPARATOR)[0];

                if (titlePrefix && categories[titlePrefix])
                    chosenCategories = [Topic.getOrCreateTopic(titlePrefix)];
            }

            // Make sure a previusly saved category is hidden from the user
            if (chosenCategories.length) {
                chosenCategories[0].set({ hidden: true });

                this.set({
                    category: chosenCategories[0].get('displayName'),
                });
            }
        },

        updateTopicCategory: function (_model, newCategory) {
            if (!newCategory)
                return;

            var chosenCategories = this.topics.getCategoryTopics();
            _.each(chosenCategories, this.topics.remove, this.topics);

            var newTopic = Topic.getOrCreateTopic(newCategory);
            newTopic.set({ hidden: true });
            this.topics.add(newTopic);
        },

        validate: function (attrs) {
            var errs = _.compact([
                this.thread.validate(_.pick(attrs, this.editableThreadAttrs)),
                this.topics.validate(),
            ]);

            return errs.length ? errs : null;
        },

        toJSON: function () {
            return _.defaults({
                thread: this.thread.toJSON(),
            }, Backbone.Model.prototype.toJSON.call(this));
        },

        saveVisibleTopics: function () {
            this.topics.save();
        },

    });

    return DiscussionCreateViewModel;
});

